import { PipelineLoan } from './types';
import { getCanonicalFundedDate } from './reporting/reportEvents';
import { startOfMonth, addMonths, isAfter, format } from 'date-fns';

// Strict funded date — no closing_date fallback.
// Only returns a date if the loan was actually funded.
export function getStrictFundedDate(loan: PipelineLoan): string | null {
  return getCanonicalFundedDate(loan);
}

// Group loans into a contiguous month series (including zero-loan months)
export function groupLoansByMonth(
  loanList: PipelineLoan[],
  from: Date,
  to: Date
): { key: string; label: string; loans: PipelineLoan[] }[] {
  const months: { key: string; label: string; loans: PipelineLoan[] }[] = [];
  let current = startOfMonth(from);
  const end = startOfMonth(to);

  while (!isAfter(current, end)) {
    months.push({
      key: format(current, 'yyyy-MM'),
      label: format(current, 'MMM yyyy'),
      loans: []
    });
    current = addMonths(current, 1);
  }

  loanList.forEach((loan) => {
    const fundedDate = getStrictFundedDate(loan);
    if (!fundedDate) {
return;
}
    const monthKey = fundedDate.slice(0, 7);
    const bucket = months.find((m) => m.key === monthKey);
    if (bucket) {
bucket.loans.push(loan);
}
  });

  return months;
}
